enum CardType {
  RECORDS_CADENCE_EFFECTIVENESS = "recordsCadenceEffectiveness",
  ACTIVITIES_LOGGED = "activitiesLogged",
  ACTIVITIES_OVERDUE = "activitiesOverdue",
  CHECK_INS = "checkIns",
  CUSTOMER_FACE_TIME = "customerFaceTime",
  CLOSED_STAGE_DEAL_AMOUNT = "closedStageDealAmount",
  CLOSED_STAGE_DEAL_COUNT = "closedStageDealCount",
  DRIVE_TIME = "mileageTracking",
  NEW_RECORDS = "newRecords",
  NEW_ROUTES = "newRoutes",
  NO_CONTACT_IN = "noContactIn",
  NO_CONTACT_IN_COUNT = "noContactInCount",
  NOTE_COMPLETION = "noteCompletion",
  OPEN_STAGE_DEAL_AMOUNT = "openStageDealAmount",
  OUT_OF_FREQUENCY = "outOfFrequency",
  RECORDS_PAST_DUE = "recordsPastDue",
  UPCOMING_ACTIVITIES = "upcomingActivities",
  AVERAGE_STOPS_PER_ROUTE = "averageStopsPerRoute",
  DISTANCE_TRAVELLED = "distanceTravelled",
  EFFICIENCY_TRACKER = "efficiencyTracker",
  EFFICIENCY_MAP = "efficiencyMap",
  SKIPPED_RECORDS = "skippedRecords",
  FREQUENCY_DURING_ACTIVITY = "frequencyDuringActivity",
  FREQUENCY_COVERAGE = "frequencyCoverage",
  FIELD_TIME = "fieldTime",
}

export const efficiencyCardTypes: CardType[] = [
  CardType.AVERAGE_STOPS_PER_ROUTE,
  CardType.CUSTOMER_FACE_TIME,
  CardType.DISTANCE_TRAVELLED,
  CardType.DRIVE_TIME,
  CardType.FIELD_TIME,
  CardType.EFFICIENCY_MAP,
  CardType.EFFICIENCY_TRACKER,
  CardType.FREQUENCY_COVERAGE,
  CardType.FREQUENCY_DURING_ACTIVITY,
  CardType.SKIPPED_RECORDS,
  CardType.NOTE_COMPLETION,
  CardType.RECORDS_CADENCE_EFFECTIVENESS,
];

export default CardType;
